import React from 'react';
import { BannerTypes } from '@gin-betting/banners';
import CollapsibleContainer from '@gin-betting/components/collapsible-container';
import { TimePeriod } from '@gin-betting/constants';
import core, { App } from '@gin-betting/core';
import { keys } from 'lodash';

import { useAppliedFilters } from 'hooks';
import features from 'services/feature-manager';
import UserDevice from 'services/user-device';
import { WIDGETS } from '../../constants';
import type { WidgetType } from '../../types';
import { getAttributesByPeriod } from '../../utils';
import ColorfulBanners from '../ColorfulBanners';
import TopMatch from './TopMatch';

import './topMatchList.scss';

interface Props {
    sportType: App.SportType;
}

const topMatchListIndexConfig: { [key in WidgetType]: number } = {
    daily: TimePeriod.Daily,
    weekly: TimePeriod.Weekly,
    monthly: TimePeriod.Monthly,
};

const attributesByType = getAttributesByPeriod(topMatchListIndexConfig);

const {
    constants: { SportType },
} = core;

const TopMatchList: React.FC<Props> = ({ sportType }) => {
    const filters = useAppliedFilters();
    const isCollapsed = keys(filters).length > 0;

    const isMixPage = sportType === SportType.Mix;

    const isHideWidgetTopMatches = features.isActive(
        features.list.WidgetHideTopMatches
    );

    return (
        <CollapsibleContainer isCollapsed={isCollapsed} duration={500}>
            {isMixPage && (
                <ColorfulBanners
                    zoneLocation={BannerTypes.BannerZoneLocation.TOP_SLIDER}
                />
            )}
            <div styleName="widget-wrapper">
                {!UserDevice.getInstance()?.isDeviceMobile() &&
                    !isHideWidgetTopMatches &&
                    WIDGETS.map((type, index) => {
                        const zoneAttributes = attributesByType[type];

                        if (!zoneAttributes || index >= 2) {
                            return null;
                        }

                        return (
                            <TopMatch
                                key={type}
                                type={type}
                                zoneAttributes={zoneAttributes}
                            />
                        );
                    })}
            </div>
        </CollapsibleContainer>
    );
};

export default TopMatchList;
